import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import assignmentV2ResultsUtils from '../assignmentV2Results.utils';
import {Table, Column} from 'sg/Tables/Table/Table.react';
import {makeLinkRowProps} from 'sg/Tables/Table/table.utils';
import {renderDuration} from 'lib/timeUtils';
import AssignmentCompletionStatus from
  'client/Classrooms/shared/AssignmentCompletionStatus/AssignmentCompletionStatus.react';
import LoadingIndicator from 'generic/LoadingIndicator.react';
import QuestionDifficultyLabel from 'generic/QuestionDifficultyLabel/QuestionDifficultyLabel.react';
import appStore from 'client/AppStore';
import {IE_EXAMS} from 'client/routes';
import './assignment-results-questions-list.scss';

export default class AssignmentResultsQuestionsList extends React.Component {
  static propTypes = {
    activeSectionId: PropTypes.string
  };

  makeQuestionLink = makeLinkRowProps((question) => {
    return `${IE_EXAMS.getTeacherRouteForExam(appStore.routerProps.params.examId)}?questionId=${question.getId()}`;
  });

  render() {
    const activeSectionId = this.props.activeSectionId;
    if (!assignmentV2ResultsUtils.getAssignmentQuery().isResourcePopulated()) {
      return <LoadingIndicator />;
    }
    const assignment = assignmentV2ResultsUtils.getAssignmentQuery().getResource();
    const activeSection = assignment
      .getSections()
      .find((section) => section.getId() === activeSectionId);
    const questions = activeSection.getAllQuestions();
    return (
      <Table
        data={questions}
        storeName='AssignmentResultsQuestionsListStore'
        rowPropsFunc={this.makeQuestionLink}
      >
        <Column
          sortable
          heading=''
          sortBy={(question) => question.getDifficulty()}
          content={(question) => (
            <QuestionDifficultyLabel
              short
              difficulty={question.getDifficulty()}
            />
          )}
        />
        <Column
          sortable
          heading='Title'
          content={(question) => {
            const position = activeSection.getQuestionPositionMap()[question.getId()];
            return `${position}. ${question.getTitle()}`;
          }}
          grow={3}
        />
        <Column
          sortable
          sortBy={(question) => question.getSectionAverageTimeElapsed()}
          heading='Time spent'
          content={(question) => {
            const timeSpent = moment.duration(question.getSectionAverageTimeElapsed());
            const formatted = renderDuration(timeSpent, {style: 'hh:mm:ss'});
            return `${formatted}s`;
          }}
          grow={1}
        />
        <Column
          sortable
          sortBy={(question) => question.getSectionCountOfCorrectGuesses()}
          heading='Answered correctly'
          content={(question) => {
            const correctCount = question.getSectionCountOfCorrectGuesses();
            const incorrectCount = question.getSectionCountOfIncorrectGuesses();
            const studentCount = activeSection.getStudents().size;
            return (
              <div className='assignment-results-questions-list-correct'>
                <div className='assignment-results-questions-list-correct__count'>
                  {correctCount} / {studentCount}
                </div>
                <AssignmentCompletionStatus
                  tiny
                  numberSubmitted={correctCount}
                  numberSubmittedLate={incorrectCount}
                  numberNotSubmitted={studentCount - (correctCount + incorrectCount)}
                />
              </div>
            );
          }}
        />
      </Table>
    );
  }
}
